<template>
<div class="flex flex-col rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-100">
  <div v-if="hasCover" class="flex-shrink-0">
    <router-link :to="route">
      <responsive-image class="h-48 w-full object-cover" :media="article.cover" :sizes="['large', 'medium']" />
    </router-link>
  </div>
  <div class="flex-1 bg-white p-6 flex flex-col justify-between">
    <div class="flex-1">
      <router-link class="block mt-2" :to="route">
        <p class="text-xl font-bold">
          {{ title }}
        </p>
        <p class="mt-3 text-base text-grey-darkest leading-normal">
          {{ intro }}
        </p>
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import ResponsiveImage from '@/components/images/ResponsiveImage'
import HasOfferArticle from '@/components/offers/HasOfferArticle'

export default {
  mixins: [HasOfferArticle],

  props: {
    offer: {
      required: true,
      type: Object,
    },
  },

  components: {
    ResponsiveImage,
  },

  computed: {
    route() {
      return {
        name: 'offer-page',
        params: {
          shortId: this.offer.short_id,
          slug: this.offer.slug,
        }
      }
    },
  },
}
</script>
